
import React from "react";
import FamilyMembership from "@/components/funnel/FamilyMembership";

const PostCTA = ({ source = "blog" }: { source?: string }) => {
  return (
    <div className="mx-auto mb-10 max-w-4xl">
      <FamilyMembership source={source} title="Make this idea personal to your family" />
    </div>
  );
};

export default PostCTA;
